import React from 'react';
import styles from './bundle_table.module.scss';

/**
 * Placeholder for bundle table.
 */
export const BundlePlaceholder: React.FC = () => (
  <p className={styles.placeholder}>
    Inga produkter än. Lägg till en nedanför
  </p>
)